import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, Button, Container, Row, Col, Form } from 'react-bootstrap';
import marriage from '../../assets/img/seeking/marriage.svg';
import friend from '../../assets/img/seeking/friend.svg';
import timepass from '../../assets/img/seeking/timepass.svg';
import marriageactive from '../../assets/img/seeking/marriageactive.svg';
import friendactive from '../../assets/img/seeking/friendactive.svg';
import timepassactive from '../../assets/img/seeking/timepassactive.svg';
import male from '../../assets/img/interest/male.svg';
import female from '../../assets/img/interest/female.svg';
import other from '../../assets/img/interest/other.svg';
import maleactive from '../../assets/img/interest/maleactive.svg';
import femaleactive from '../../assets/img/interest/femaleactive.svg';
import otheractive from '../../assets/img/interest/otheractive.svg';
import arrowright from '../../assets/img/icons/rightarrow.svg';
import close from '../../assets/img/icons/close.svg'
import Filterreligion from './filterreligion';
import Filterlanguage from './filterlanguage';
import ReactSlider from 'react-slider';
import InputRange from 'react-input-range-rtl';
import ls from "local-storage";
import axios from 'axios';
import Location from '../commoncomponents/location';
import Join from '../main/plan/join';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Filter extends Component {
    constructor(props) {
        super(props);
        this.filterchange = this.filterchange.bind(this);
        this.state = {
            selectedOptions: {
                male: false,
                female: false,
                others: false,
                marriage: false,
                friend: false,
                timepass: false,
            },
            premiummodal: false,
            locationmodal: false,
            filterreligionmodal: false,
            filterlangaugemodal: false,
            distance: 0,
            age: [],
            age_i: {
                min: '',
                max: '',
            },
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            selectedPeoplefor: [],
            seekings_data: [],
            max_distance: '',
            max_age: '',
        };
    }

    componentDidMount() {
        axios.get(this.state.api_url+`admindatas`)
        .then(res => {
            const seekings_data = res.data.result.peoplefor;
            const max_distance = res.data.result.max_distance;
            const max_age = res.data.result.max_age;
            this.setState({ 
                seekings_data: seekings_data,
                max_distance: max_distance,
                max_age: max_age,
            });	
        });

        let data = new FormData(); 
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            if(res.data.status !== false) {
                const user_details = res.data.result;
                const filter_details = res.data.result.filter;
                const filter_age = user_details.filter_age;
                const age_fil = filter_age.split("-"); 
                // console.log("USER DETAILS: ", user_details);
                // console.log("FILTER DETAILS: ", filter_details);
                this.setState({
                    user_details: user_details,
                    selectedOptions: user_details.filter_gender,
                    selectedPeoplefor: user_details.filter_peoplefor,
                    location: user_details.location,
                    age: [parseInt(age_fil[0]), parseInt(age_fil[1])],
                    age_i: { min: age_fil[0], max: age_fil[1] },
                    filter_distance: user_details.filter_distance,
                    filter_relogion1: user_details.filter_relogion1,
                    filter_language1: user_details.filter_language1,
                });
            } else { 
                this.props.history.push("/"); 
            }  
        }).catch(error => {
            this.props.history.push("/");
        });
    }

    toggleOption = (option, row) => {
        if (row === 'gender') {
            this.setState({
                selectedOptions: option
            });
        } else if (row === 'seeking') {
            const { selectedPeoplefor } = this.state;
            if (selectedPeoplefor.includes(option.toString())) {
                this.setState({
                    selectedPeoplefor: selectedPeoplefor.filter(item => item !== option.toString()),
                });
            } else {
                this.setState({
                    selectedPeoplefor: [...selectedPeoplefor, option.toString()],
                });
            }
        }
    };

    handleFilterReligionOpenModal = () => {
        this.setState({ filterreligionmodal: true });
    }

    handleFilterReligionCloseModal = () => {
        this.setState({ filterreligionmodal: false });
    }

    handleFilterLanguageOpenModal = () => {
        this.setState({ filterlangaugemodal: true });
    }

    handleFilterLanguageCloseModal = () => {
        this.setState({ filterlangaugemodal: false });
    }

    handleDistanceChange = (value) => {
        this.setState({ filter_distance: value });
    };

    handleAgeChange = (value) => {
        console.log("handleAgeChange: ", value);
        this.setState({ age: value });
        this.setState({ age_i: value });
    };

    handleLocationOpenModal = () => {
        if(this.state.user_details.premium_member == "true"){
            this.setState({ locationmodal: true });
        }else{
            this.setState({ premiummodal: true });
        }
    }

    handleLocationCloseModal = () => {
        this.setState({ locationmodal: false });
    }

    handlePremiumCloseModal = () => {
        this.setState({ premiummodal: false });
    }

    filterchange() {
        const filter_languages = (localStorage.getItem('selected_filterlanguage') !== '' && localStorage.getItem('selected_filterlanguage') !== null) ? localStorage.getItem('selected_filterlanguage') : this.state.filter_language1;
        const filter_religions = (localStorage.getItem('seleted_filterreligion') !== '' && localStorage.getItem('seleted_filterreligion') !== null) ? localStorage.getItem('seleted_filterreligion') : this.state.filter_relogion1;
        var filter = new FormData();
        filter.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        filter.append('age', ''+parseInt(this.state.age_i.min)+'-'+parseInt(this.state.age_i.max));
        filter.append('distance', this.state.filter_distance);
        filter.append('gender', this.state.selectedOptions);
        filter.append('people_for', this.state.selectedPeoplefor);
        filter.append('relogion', filter_religions);
        filter.append('user_languages', filter_languages);
        filter.append('place', localStorage.getItem('place'));
        filter.append('lat', localStorage.getItem('lat'));
        filter.append('lon', localStorage.getItem('lon'));
        axios({
            method: 'post',
            url: this.state.api_url+'websetfilter',
            data: filter,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== false) {
                this.props.handleClose();
                if(localStorage.getItem('filter_page') === '1') {
                    this.props.history.push("/people");
                    window.location.reload();
                } else {
                    this.props.history.push("/find");
                    window.location.reload();
                }
            }
        });
    }

    render() {
        const { selectedPeoplefor, selectedOptions, age, age_i } = this.state;
        const { t } = this.props;
        return (
            <div>
                <div className="">
                    <Modal className="modal_div" show={this.props.showModal} onHide={this.props.handleClose} centered>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Filter">Filter</Trans></Modal.Title>
                            <Button className="close" onClick={this.props.handleClose}>
                                <img src={close} alt="img" />
                            </Button>
                        </Modal.Header>
                        <Modal.Body className="religion_modal">
                            <div className='seeking_height'>
                                <Container>
                                    {/* Gender */}
                                    <div>
                                        <h4 className='filter_subtitle'><Trans i18nKey="I'm interested in">I'm interested in</Trans></h4>
                                        <Row>
                                            <Col md={4} sm={4}>
                                                <div className={`seeking_div ${selectedOptions === "male" ? 'seekingselect' : ''}`} onClick={() => this.toggleOption('male', 'gender')}>
                                                    <div className='seeking_subdiv'>
                                                        <img src={male} alt="img" />
                                                        <img src={maleactive} alt="img" />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={4} sm={4}>
                                                <div className={`seeking_div ${selectedOptions === "female" ? 'seekingselect' : ''}`} onClick={() => this.toggleOption('female', 'gender')}>
                                                    <div className='seeking_subdiv'>
                                                        <img src={female} alt="img" />
                                                        <img src={femaleactive} alt="img" />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={4} sm={4}>
                                                <div className={`seeking_div ${selectedOptions === "everyone" ? 'seekingselect' : ''}`} onClick={() => this.toggleOption('everyone', 'gender')}>
                                                    <div className='seeking_subdiv'>
                                                        <img src={other} alt="img" />
                                                        <img src={otheractive} alt="img" />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Peoplefor */}
                                    <div>
                                        <h4 className='filter_subtitle'><Trans i18nKey="I'm here to">I'm here to</Trans></h4>
                                        <Row>
                                            {this.state.seekings_data.map(seeking => (
                                                <Col md={4} sm={4}>
                                                    <div className={`seeking_div filter_pdiv ${selectedPeoplefor.includes(seeking.id.toString()) === true ? 'seekingselect' : ''}`} onClick={() => this.toggleOption(seeking.id, 'seeking')}>
                                                        <div className='seeking_subdiv seeking_imgs'>
                                                            <img src={seeking.icon} alt="img" />
                                                            {/* <img src={marriageactive} alt="img" /> */}
                                                        </div>
                                                        <p>{seeking.name}</p>
                                                    </div>
                                                </Col>
                                            ))}
                                        </Row>
                                    </div>

                                    <div className='filter_form'>
                                        {/* Location */}
                                        <Form.Group controlId="formPlaintextEmail" className="filter_form_div">
                                            <Form.Label><Trans i18nKey="Location">Location</Trans></Form.Label>
                                            <div>
                                                <Form.Control value={this.state.location} placeholder={t("Enter your location")} disabled/>
                                            </div>
                                            <div className="filterchange_btn">
                                                <Button type="submit" onClick={this.handleLocationOpenModal}><Trans i18nKey="CHANGE LOCATION">CHANGE LOCATION</Trans></Button>
                                            </div>
                                        </Form.Group>
                                        
                                        {/* Religion */}
                                        <Form.Group controlId="formPlaintextEmail" className="filter_form_div">
                                            <Form.Label><Trans i18nKey="Religion">Religion</Trans></Form.Label>
                                            <Form.Control value={(localStorage.getItem('seleted_filterreligion') !== '' && localStorage.getItem('seleted_filterreligion') !== null) ? localStorage.getItem('seleted_filterreligion') : this.state.filter_relogion1} onClick={this.handleFilterReligionOpenModal} placeholder={t("Select the Religion")}/>
                                        </Form.Group>

                                        {/* Language */}
                                        <Form.Group controlId="formPlaintextEmail" className="filter_form_div">
                                            <Form.Label><Trans i18nKey="Language">Language</Trans></Form.Label>
                                            <Form.Control value={(localStorage.getItem('selected_filterlanguage') !== '' && localStorage.getItem('selected_filterlanguage') !== null) ? localStorage.getItem('selected_filterlanguage') : this.state.filter_language1} onClick={this.handleFilterLanguageOpenModal} placeholder={t("Select the Language")}/>
                                        </Form.Group>

                                        {/* Age */}
                                        <Form.Group controlId="formPlaintextEmail" className="filter_form_div">
                                            <div className='filter_ageform'>
                                                <Form.Label><Trans i18nKey="Age between">Age between</Trans></Form.Label>
                                                <Form.Label>{age_i.min} - {age_i.max}</Form.Label>
                                            </div>
                                            <div className='rangeslider_div_age'>
                                                <InputRange
                                                    maxValue={this.state.max_age}
                                                    minValue={18}
                                                    value={age_i}
                                                    direction=''
                                                    onChange={this.handleAgeChange}
                                                    onChangeComplete={value => console.log(value)} 
                                                />
                                            </div>
                                        </Form.Group>
                                        
                                        {/* Distance */}
                                        <Form.Group controlId="formPlaintextEmail" className="filter_form_div">
                                            <div className='filter_ageform'>
                                                <Form.Label><Trans i18nKey="Distance">Distance</Trans></Form.Label>
                                                <Form.Label>{this.state.filter_distance} <Trans i18nKey="KM">KM</Trans></Form.Label>
                                            </div>
                                            <div className='rangeslider_div'>
                                                <ReactSlider
                                                    className="range_Slider distance-slider"
                                                    thumbClassName="example-thumb"
                                                    trackClassName="example-track"
                                                    ariaLabel={['Lower thumb', 'Upper thumb']}
                                                    value={this.state.filter_distance}
                                                    min={0}
                                                    max={parseInt(this.state.max_distance)}
                                                    onChange={this.handleDistanceChange}
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </Container>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="forgot_button_plr filter_plr">
                            <Button type="submit" className='button_primary' onClick={this.filterchange}><Trans i18nKey="Save">Save</Trans></Button>
                        </Modal.Footer>
                    </Modal>

                </div>
                <Filterreligion
                    showModal={this.state.filterreligionmodal}
                    handleClose={this.handleFilterReligionCloseModal}
                />
                <Filterlanguage
                    showModal={this.state.filterlangaugemodal}
                    handleClose={this.handleFilterLanguageCloseModal}
                />
                <Location
                    showModal={this.state.locationmodal}
                    handleClose={this.handleLocationCloseModal}
                />
                <Join
                    showModal={this.state.premiummodal}
                    handleClose={this.handlePremiumCloseModal}
                />
            </div>
        );
    }
}

export default withTranslation("translations")(withRouter(Filter));